export default __webpack_public_path__ + "static/media/logo-main.5a9d79eb.png";